import { mergeDeepRight } from 'ramda'
import React from 'react'

import { Pie } from '@ant-design/plots'

const PieChart = ({ data, ...props }) => {
  const config = mergeDeepRight(
    {
      data,
      appendPadding: 10,
      animation: false,
      radius: 0.9,
      label: {
        type: 'inner',
        offset: '-30%',
        content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
        style: {
          fontSize: 14,
          textAlign: 'center'
        }
      },
      interactions: [
        {
          type: 'element-active'
        }
      ]
    },
    props
  )

  return <Pie {...config} />
}

export default PieChart
